import { ApiListRelationship, ApiModel, ApiResource } from 'lib/interfaces/api';

export interface EnvironmentQuota {
  action: EnvironmentQuotaAction;
  period: EnvironmentQuotaPeriod;
  limit: number;
}

/**
 * Keep in sync with backend: Environment::Quota::Action
 * app/models/environment.rb
 */
export enum EnvironmentQuotaAction {
  CreateCase = 'create_case',
  CreateInquiry = 'create_inquiry',
  CreateInquiryPerAccount = 'create_inquiry_per_account',
  CreateReport = 'create_report',
  // Controls sync creation of reports via external API. Not surfacing to end users for now.
  // CreateReportSync = 'create_report_sync',
  // Controls transaction creation via the Sentinal controller. Not surfacing to end users for now.
  // CreateSentinelTransaction = 'create_sentinel_transaction',
  CreateTransaction = 'create_transaction',
  CreateVerification = 'create_verification',
  CreateWorkflowRun = 'create_workflow_run',
  SendEmail = 'send_email',
}

export enum EnvironmentQuotaPeriod {
  Minute = 'minute',
  Hour = 'hour',
  Day = 'day',
  Month = 'month',
  Year = 'year',
}

export interface EnvironmentAttributes {
  'rate-limit'?: {
    limit: number;
    'period-seconds': number;
  };
  quotas?: EnvironmentQuota[];
  'workflow-secret-key'?: string;
  status: EnvironmentStatus;
  name: string;
}

export interface EnvironmentRelationships {
  'api-keys': ApiListRelationship<ApiModel.ApiKey>;
}

export type EnvironmentSandbox = ApiResource<
  EnvironmentAttributes,
  EnvironmentRelationships,
  ApiModel.EnvironmentSandbox
>;

export type EnvironmentProduction = ApiResource<
  EnvironmentAttributes,
  EnvironmentRelationships,
  ApiModel.EnvironmentProduction
>;

export type Environment = EnvironmentSandbox | EnvironmentProduction;

export type EnvironmentType = Environment['type'];

export type EnvironmentName = string;

export enum EnvironmentStatus {
  Active = 'active',
  Paused = 'paused',
}
